module.exports = __webpack_public_path__ + "static/avatar_pavel_osipov-601918dc9984587fb37d2421e12e83ba.jpg";